/**
 * @deprecated migrate to services/storefront/themes/v2/lib/customer/useCustomer.ts
 */
export const TOKEN_COOKIE = 'auth-token';
/**
 * @deprecated migrate to services/storefront/themes/v2/lib/customer/useCustomer.ts
 */
export const EXPIRE_COOKIE = 'auth-expire'; // we can't get with Javascript the expiration time of the cookie. So we store it.
